import React, { useContext, useEffect, useState } from 'react'
import { TheMasterContext } from '../../../../MyContexts/Master_Context';
import SelectImgComp from '../../../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../../../MySections/ImagesSetter/SelectImgDelay';

const TabPopUps = (props) => {
    const [theMaster] = useContext(TheMasterContext);

    const [oopsPopImg, setOopsPopImg] = useState(theMaster.oopsPopImg);
    const [orderApprovImg, setOrderApprovImg] = useState(theMaster.orderApprovImg);


    useEffect(() => {

    }, [])


    const setOpsPopImg = (impSrc) => {
        theMaster["oopsPopImg"] = impSrc;
        setOopsPopImg(impSrc);

    }

    const setApproveTblImgPopImg = (impSrc) => {
        theMaster["orderApprovImg"] = impSrc;
        setOrderApprovImg(impSrc);

    }

    return (
        <>

            <div className={"col-md-12 mb-2"}>

                <div className={"col-md-3 mb-2"}>
                    <label htmlFor={"validationCustom1_6"}>תמונת פופ אפ</label>
                    <span className={"explanation mediumst fullROw"}>התמונה שתוצג בפופאפ הגדול</span>

                    <SelectImgComp firstImgToDisp={oopsPopImg ? oopsPopImg : ""} theFunction={(fUrl) => setOpsPopImg(fUrl)} />
                </div>

                <div className={"col-md-3 mb-2"}>
                    <label htmlFor={"validationCustom1_7"}>ההזמנה בוצעה</label>
                    <span className={"explanation mediumst fullROw"}>התמונה שתוצג בפופאפ אישור הזמנת שולחן</span>
                    <SelectImgComp firstImgToDisp={orderApprovImg ? orderApprovImg : ""} theFunction={(fUrl) => setApproveTblImgPopImg(fUrl)} />

                </div>
            </div>



        </>

    )
}

export default TabPopUps;